<template>
  <Message severity="error" class="my-2" icon="pi pi-exclamation-triangle" @close="onMessageClose" closable v-if="visible">
    {{ message }}
  </Message>
</template>

<script setup>
import Message from 'primevue/message';

const onMessageClose = () => {
    emit('close');
};

defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    message: {
        type: String,
        default: 'An error has occurred while processing your request. Please try again.'
    }
});

const emit = defineEmits(['close']);

</script>
